import React from 'react';
import { connect } from 'react-redux';
import SignInComponent from "./signin_component/signin_component";
import SignupComponent from "./signup_component/signup_component";
import ResetPasswordComponent from "./reset_password_component/reset_password_component";
import EmailConfirmationComponent from "./email_confirmation_component/email_confirmation_component";
import OtpScreen from "./otp_screen_component/otp_screen_component";
import classnames from 'classnames';
import './form_login_modal.scss';
import './input_field/input_field.scss';
import './button_component/button_component.scss';
import MetypeBlueLogo from "./metype_blue_logo";
import { isValidValue } from "./../../../util/pure_functions/utils";

class FormLoginModal extends React.Component {
  constructor(props) {
    super(props)
  }

  accountLogo() {
    if(window.metypeAccount) {
      if (isValidValue(window.metypeAccount.logo)) {
        return <img src={window.metypeAccount.logo} />
      } else {
        return <strong> {window.metypeAccount.name} </strong>
      }
    }
    else {
      return <strong> Metype </strong>
    }
  }

  loginModal() {
    let accountLogo = this.accountLogo();
    const loginModal =
    <div className="metype-login-modal__container">
      <div className="metype-login-modal__popup">
        <div className="metype-login-modal__popup--header">
          <div className="client-logo">
            {this.accountLogo()}
          </div>
          {this.headerMessage()}
        </div>
        <div className="metype-login-modal__popup--body">
          <form id="metype-form">
            {this.signinComponent()}
            {this.signupComponent()}
            {this.otpScreen()}
            {this.emailConfirmationScreen()}
            {this.resetPasswordScreen()}
          </form>
        </div>
      </div>
      <div className="metype-login-modal__footer">
        By signing in you indicate to accept
        Metype’s <a href="https://www.quintype.com/terms" target="_blank">Terms of Service</a> & <a href="https://www.quintype.com/privacy-policy" target="_blank">Privacy Policy.</a>
        <a href="https://www.metype.com" target="_blank" className="link-to-home">
          <span className="powered_by">Powered by</span>
          <MetypeBlueLogo />
        </a>
      </div>
    </div>
    return loginModal;
  }

  emailConfirmationScreen() {
    return(
      <div className={this.setEmailConfirmationScreenClass()}>
        <EmailConfirmationComponent />
      </div>
    )
  }

  resetPasswordScreen() {
    return(
      <div className={this.setResetPasswordScreenClass()}>
        <ResetPasswordComponent />
      </div>
    )
  }

  setResetPasswordScreenClass() {
    const resetPasswordScreenClass = classnames('reset-password-component-parent',
                                     {'reset-password-component-parent-visible': (this.props.screen === 'resetPassword')});
    return resetPasswordScreenClass;
  }

  setEmailConfirmationScreenClass() {
    const emailConfirmationClass = classnames('email-confirmation-component-parent',
                                     {'email-confirmation-component-parent-visible': (this.props.screen === 'emailConfirmation')});
    return emailConfirmationClass;
  }

  headerMessage() {
    const screen = this.props.screen;
    if(screen === 'signup') {
      return <div className="header-message">Sign up to continue</div>
    } else if(screen === 'signin') {
      return <div className="header-message">Sign in to continue</div>
    } else if(screen === 'emailConfirmation' || screen === "resetPassword") {
      return <div className="header-message">Reset password</div>
    }
  }

  otpScreen() {
    return(
      <div className={this.setOtpScreenClass()}>
        <OtpScreen userLogin={this.props.userLogin}
                   action={this.props.action} />
      </div>
    )
  }

  setOtpScreenClass() {
    const otpScreenClass = classnames('otp-component-parent',
                                     {'otp-component-parent-visible': (this.props.screen === 'confirmOtp')});
    return otpScreenClass;
  }

  signinComponent() {
    return(
      <div className={this.setSigninComponentClass()}>
        <SignInComponent userLogin={this.props.userLogin}
                         action={this.props.action}/>
      </div>
    )
  }

  setSigninComponentClass() {
    const signinComponentClass = classnames('signin-component-parent',
                                            {'signin-initial-load': this.props.initialLoad},
                                            {'signin-latter-load': !this.props.initialLoad},
                                           {'signin-component-parent-visible': (this.props.screen === 'signin')},
                                          {'signin-component-parent-invisible': (this.props.screen !== 'signin')});
    return signinComponentClass;
  }

  setSignupClass() {
    const signupClass = classnames('signup-component-parent',
                                   {'signup-component-parent-visible': (this.props.screen === 'signup')});
    return signupClass;
  }

  signupComponent() {
    return(
      <div className={this.setSignupClass()}>
        <SignupComponent userLogin={this.props.userLogin} />
      </div>
    )
  }

  render() {
    return <div className="metype-login-modal" id="login-modal-container">
            <div className="close-login"
                 onClick={() => this.props.closeLogin()}></div>
            {this.loginModal()}
           </div>
  }
}

const mapStateToProps = ({formLoginReducers}) => {
  return {
    screen: formLoginReducers.screen,
    initialLoad: formLoginReducers.initialLoad
  }
}

export default connect(mapStateToProps)(FormLoginModal);


// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/form_login_modal.js